import { useMediaQuery } from '@mui/material';

export function useScreenSize() {
  return {
    xsScreen: useMediaQuery((theme) => theme.breakpoints.down('sm'), {
      noSsr: true,
    }),
    smScreen: useMediaQuery((theme) => theme.breakpoints.down('md'), {
      noSsr: true,
    }),
    mdScreen: useMediaQuery((theme) => theme.breakpoints.down('lg'), {
      noSsr: true,
    }),
  };
}
